import React from 'react'
import styled from 'styled-components'

const NumericalValue = styled.div<{ fontSize?: string }>`
  font-family: Montserrat-Medium;
  color: ${({ theme }) => theme.poolValueTextColor};
  pointer-events: auto;
  font-size: ${({ fontSize }) => fontSize? fontSize : '2rem'};
  align-self: center;
  padding: 0;
  vertical-align: center;
`

export default NumericalValue
